/**
 * Generate a simple UUID for file tracking
 */
export const generateFileId = () => {
  return `file_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;
};
export const convertToBreezeFiles = files => {
  return files.filter(file => file.fileManagerId !== undefined).map(file => ({
    id: file.fileManagerId,
    name: file.name
  }));
};
export const getFileMimeType = extension => {
  switch (extension) {
    case 'pdf':
      return 'application/pdf';
    case 'jpg':
    case 'jpeg':
      return 'image/jpeg';
    case 'png':
      return 'image/png';
    case 'gif':
      return 'image/gif';
    default:
      return '';
  }
};

/**
 * Convert a local File to FileData for the Redux store
 */
export const mapLocalFileToFileData = ({
  file,
  uniqueId,
  threadId,
  extension
}) => {
  return {
    uniqueId,
    threadId,
    name: file.name,
    extension,
    size: file.size,
    type: file.type,
    status: 'PENDING'
  };
};

/**
 * Convert an FMFile to FileData for the Redux store
 */
export const mapFMFileToFileData = ({
  file,
  uniqueId,
  threadId
}) => {
  return {
    uniqueId,
    threadId,
    fileManagerId: file.id,
    url: file.url,
    name: file.name,
    extension: file.extension,
    size: file.size,
    type: getFileMimeType(file.extension),
    status: 'PENDING'
  };
};